module.exports = __webpack_public_path__ + "img/no_posh.ef4603b1.svg";